export default __webpack_public_path__ + "static/media/Jason Coudriet.ab1651bc.png";